<template>
   
  <v-app>
    <account-head></account-head>
    <div class="application-main">
      <login></login>
    </div>
    <account-footer></account-footer>
  </v-app>
</template>
<style>
  .application-main {
    min-width: 768px;
    width: 100%;
    margin-top: 51px;
  }
</style>
<script>
  import accountHead from './account-head'
  import accountFooter from './account-footer'

  import login from './login/login'

  export default {
    data() {
      return {}
    },
    components: {
      accountHead,
      accountFooter,
      login
    }
  }
</script>
